import * as React from "react";
import styled, { css } from "../../styled/index";

interface Props extends React.HtmlHTMLAttributes<HTMLDivElement> {
  text: React.ReactNode;
  width: number;
  position: "left" | "right" | "top" | "bottom";
  offset?: number;
  disable?: boolean;
}

const TooltipWrapper = styled("div")`
  position: relative;
  display: inline-block;
  &:hover {
    > .tooltip-text {
      visibility: visible;
      opacity: 1;
    }
  }
`;

const TooltipText = styled("div")<Props>`
  width: ${({width}) => width}px;
  visibility: hidden;
  background-color: #343434;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 3px;
  position: absolute;
  z-index: 1;
  
  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.12s;
  
  ::after {
    content: "";
    position: absolute;
    border-width: 5px;
    border-style: solid;
  }
  
  ${({position}) => position === "left" ? css`
    top: 50%;
    transform: translateY(-50%);
    right: 125%;
    ::after {
      top: 50%;
      left: 100%;
      margin-top: -5px;
      border-color: transparent transparent transparent #343434;
    }
  ` : ""};
  
  ${({position}) => position === "right" ? css`
    top: 50%;
    transform: translateY(-50%);
    left: 125%;
    ::after {
      top: 50%;
      right: 100%;
      margin-top: -5px;
      border-color: transparent #343434 transparent transparent;
    }
  ` : ""};
  
  ${({position}) => position === "top" ? css`
    bottom: 115%;
    left: 50%;
    transform: translateX(-50%);
    ::after {
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-color: #343434 transparent transparent transparent;
    }
  ` : ""};
  
  ${({position, offset}) => position === "bottom" ? css`
    top: calc(115% + ${offset || 0}px);
    left: 50%;
    transform: translateX(-50%);
    ::after {
      bottom: 100%;
      left: 50%;
      margin-left: -5px;
      border-color: transparent transparent #343434 transparent;
    }
  ` : ""};
 
`;

export class Tooltip extends React.PureComponent<Props> {
  render() {
    return (
      <TooltipWrapper {...this.props}>
        {this.props.children}
        {!this.props.disable &&
          <TooltipText {...this.props} className="tooltip-text">
            {this.props.text}
          </TooltipText>
        }
      </TooltipWrapper>
    );
  }
}
